// Simple soft wave decoration for the Autobusu ceļojumi background — two wide ribbons on the
// left (running behind the large featured card), two more bottom-right (diagonal, pointing up-
// right). No landmarks/mountains/vehicles/routes — just soft shapes, opacity encoded once in
// each gradient (not also on the wrapping element) so nothing compounds.

export function LeftWaves({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 400 640"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false">
      <defs>
        <linearGradient id="bus-wave-left-a" x1="0" y1="0" x2="1" y2="0.3">
          <stop offset="0" stopColor="#CFE3FC" stopOpacity="0.35" />
          <stop offset="0.6" stopColor="#CFE3FC" stopOpacity="0.2" />
          <stop offset="1" stopColor="#CFE3FC" stopOpacity="0.05" />
        </linearGradient>
        <linearGradient id="bus-wave-left-b" x1="0" y1="0.1" x2="1" y2="0.4">
          <stop offset="0" stopColor="#BDD8F8" stopOpacity="0.3" />
          <stop offset="0.6" stopColor="#BDD8F8" stopOpacity="0.16" />
          <stop offset="1" stopColor="#BDD8F8" stopOpacity="0.05" />
        </linearGradient>
      </defs>
      <path
        d="M -80 60 C 60 20, 140 140, 110 260 C 80 390, 180 460, 150 600
           C 135 650, 60 650, -80 630 Z"
        fill="url(#bus-wave-left-a)"
      />
      <path
        d="M -80 220 C 40 190, 90 320, 60 420 C 35 500, 110 560, 90 640
           L -80 640 Z"
        fill="url(#bus-wave-left-b)"
      />
    </svg>
  );
}

export function RightWaves({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 400 400"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false">
      <defs>
        <linearGradient id="bus-wave-right-a" x1="1" y1="1" x2="0.2" y2="0.1">
          <stop offset="0" stopColor="#CFE3FC" stopOpacity="0.35" />
          <stop offset="0.6" stopColor="#CFE3FC" stopOpacity="0.2" />
          <stop offset="1" stopColor="#CFE3FC" stopOpacity="0.05" />
        </linearGradient>
        <linearGradient id="bus-wave-right-b" x1="1" y1="0.9" x2="0.3" y2="0" >
          <stop offset="0" stopColor="#BDD8F8" stopOpacity="0.3" />
          <stop offset="0.6" stopColor="#BDD8F8" stopOpacity="0.16" />
          <stop offset="1" stopColor="#BDD8F8" stopOpacity="0.05" />
        </linearGradient>
      </defs>
      <path
        d="M 480 480 C 340 460, 300 340, 220 300 C 140 260, 120 150, 180 60
           C 210 15, 300 10, 480 30 Z"
        fill="url(#bus-wave-right-a)"
      />
      <path
        d="M 480 480 C 380 470, 340 400, 290 360 C 245 325, 230 240, 270 170
           L 480 170 Z"
        fill="url(#bus-wave-right-b)"
      />
    </svg>
  );
}
